import BaseService from "./BaseService";

/**
 * RegistrationService
 *
 * Service class for handling user registration related API calls.
 * Provides methods for fetching registration configuration and registering new users.
 */
class RegistrationService {
  /**
   * Fetch registration configuration for the current enterprise
   * @returns {Promise} API response with registration configuration
   */
  static async getRegistrationConfiguration() {
    return await BaseService.callAPI("/registration/configuration", "GET");
  }

  /**
   * Register a new user
   * @param {Object} data - User registration data
   * @returns {Promise} API response with registration result
   */
  static async registerUser(data) {
    return await BaseService.callAPI("/registration", "POST", data);
  }

  /**
   * Verify user email with token
   * @param {Object} data - Email verification data containing token and params
   * @returns {Promise} API response with verification result
   */
  static async verifyEmail(data) {
    return await BaseService.callAPI(
      "/registration/verify-email",
      "POST",
      data
    );
  }
}

export default RegistrationService;
